import { useEffect, useState } from 'react';
import { AlertTriangle, Bell, CheckCircle, Clock } from 'lucide-react';

interface Alert {
  id: string;
  severity: 'critical' | 'warning' | 'info';
  source: string;
  message: string;
  time: string;
  acknowledged: boolean;
}

export default function AlertsPage() {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/alerts', { credentials: 'include' })
      .then((r) => r.json())
      .then((res) => setAlerts(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-center text-slate-500">Loading alerts...</div>;

  const severityIcon = (s: string) => {
    if (s === 'critical') return <AlertTriangle size={18} className="text-rose-500" />;
    if (s === 'warning') return <Bell size={18} className="text-amber-500" />;
    return <CheckCircle size={18} className="text-sky-500" />;
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Alerts</h1>
        <button className="px-4 py-2 bg-slate-600 hover:bg-slate-700 text-white text-sm font-medium rounded-md transition-colors">
          Acknowledge All
        </button>
      </div>

      <div className="space-y-3">
        {alerts.map((a) => (
          <div key={a.id} className="flex items-start gap-4 rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
            <div className="mt-0.5">{severityIcon(a.severity)}</div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div className="font-medium text-slate-900 dark:text-white capitalize">{a.severity}: {a.source}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1"><Clock size={12} /> {a.time}</div>
              </div>
              <div className="text-sm text-slate-600 dark:text-slate-400 mt-1">{a.message}</div>
            </div>
            {!a.acknowledged && (
              <button className="text-xs px-3 py-1.5 rounded-md border border-slate-300 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800">
                Ack
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
